// import {
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   Stack,
//   Chip,
//   Alert,
//   CircularProgress,
// } from "@mui/material";
// import { useEffect, useRef, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import moment from "moment";
// import AppointmentCalendar from "../../dashboard/Appointment/AppointmentCalender";
// import {
//   handleGetAvailableFollowupSlots,
// } from "../../../redux/user-slices/appointment.slice";
// import { hideDialog, showDialogWithData } from "../../../redux/guest-slices/other.slice";
// import { useToast } from "../../../hooks/useToast";
// import { checkUserType, processAvailabilityOnFrontend } from "../../../utils/helper";
// import { APPOINTMENT_SCHEDULE } from "../../../utils/keywords";
// import { data } from "react-router-dom";

// const FollowupAppointmentDialog = () => {
//   const dispatch = useDispatch();
//   const toast = useToast();
//   const { data: modalData } = useSelector((s) => s.otherSlice);
//   const specialistTimeZoneRef = useRef("");
//   const [selectedDate, setSelectedDate] = useState(null);
//   const [selectedSlot, setSelectedSlot] = useState(null);
//   const [dayWiseAvailability, setDayWiseAvailability] = useState([]);
//   const [bookedSlots, setBookedSlots] = useState([]);
//   const [exceptions, setExceptions] = useState([]);
//   const [error, setError] = useState(null);

//   const memberId = modalData?.memberId;
//   const specialistId = modalData?.specialistId;
//   const userRole = checkUserType();
//   const isReschedule = modalData?.mode === "reschedule"

//   const handleClose = () => dispatch(hideDialog());

//   console.log(`selectedSlot:`, selectedSlot);


//   useEffect(() => {
//     if (!memberId && !specialistId) return;

//     const fetchSlots = async () => {
//       try {
//         setError(null);
//         setDayWiseAvailability([]);
//         setBookedSlots([]);

//         const params = userRole === "specialist" ? { memberId } : { specialistId };
//         const res = await dispatch(handleGetAvailableFollowupSlots(params)).unwrap();

//         const userTZ = userRole === "specialist" ? res?.specialistTimeZone : Intl.DateTimeFormat().resolvedOptions().timeZone;
//         specialistTimeZoneRef.current = userTZ;

//         // const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

//         const { weeklySchedule, bookedSlots, exceptions: fetchedExceptions } = processAvailabilityOnFrontend(res, userTZ);

//         setDayWiseAvailability(weeklySchedule);
//         setBookedSlots(bookedSlots);
//         setExceptions(fetchedExceptions || []);

//         if (weeklySchedule.length === 0) {
//           setError("No schedule found.");
//         }
//       } catch (err) {
//         setError("Failed to fetch slots.");
//       }
//     };

//     fetchSlots();
//   }, [memberId, specialistId, userRole, dispatch]);

//   const formatTime = (timeStr) => {
//     if (!timeStr) return "Invalid Time";

//     if (timeStr.includes("T") || timeStr.includes("Z")) {
//       const m = moment(timeStr);
//       return m.isValid() ? m.format("h:mm A") : "Invalid Time";
//     }

//     const m = moment(timeStr, "HH:mm");
//     return m.isValid() ? m.format("h:mm A") : "Invalid Time";
//   };

//   const generateAvailableDates = () => {
//     if (dayWiseAvailability?.length === 0) return [];

//     const dates = [];
//     const endDate = moment().add(12, "months");

//     for (
//       let date = moment().add(1, "day");
//       date.isBefore(endDate);
//       date.add(1, "day")
//     ) {
//       const dayName = date.format("dddd").toUpperCase();
//       const daySchedule = dayWiseAvailability?.find((d) => d?.day === dayName);

//       if (daySchedule) {
//         const dateStr = date.format("YYYY-MM-DD");

//         const availableCount = daySchedule?.slots?.filter((slot) => {
//           const slotKey = `${dayName}_${dateStr}T${slot.startTime}`;
//           const isBooked = bookedSlots?.includes(slotKey);

//           let isException = false;
//           if (!isBooked && exceptions?.length > 0) {
//             const slotStartMoment = moment.tz(`${dateStr} ${slot.originalStartTime}`, "YYYY-MM-DD HH:mm", specialistTimeZoneRef.current);
//             const slotEndMoment = moment.tz(`${dateStr} ${slot.originalEndTime}`, "YYYY-MM-DD HH:mm", specialistTimeZoneRef.current);

//             isException = exceptions.some((exc) => {
//               const excStart = moment(exc.start);
//               const excEnd = moment(exc.end);
//               if (exc.fullDay) {
//                 const excDateStr = excStart.tz(specialistTimeZoneRef.current).format('YYYY-MM-DD');
//                 return excDateStr === dateStr;
//               } else {
//                 return slotStartMoment.isBefore(excEnd) && slotEndMoment.isAfter(excStart);
//               }
//             });
//           }

//           return !isBooked && !isException;
//         }).length;

//         dates.push({
//           date: dateStr,
//           count: availableCount,
//           totalSlots: daySchedule?.slots?.length,
//         });
//       }
//     }

//     return dates;
//   };

//   const bookedDates = generateAvailableDates();


//   const handleDateChange = (date) => {
//     setSelectedDate(date);
//     setSelectedSlot(null);
//   };

//   const getSelectedDateSlots = () => {
//     if (!selectedDate) return [];

//     const dateStr = moment(selectedDate).format("YYYY-MM-DD");
//     const dayName = moment(selectedDate).format("dddd").toUpperCase();
//     const daySchedule = dayWiseAvailability?.find((d) => d?.day === dayName);

//     if (!daySchedule) return [];

//     return daySchedule.slots.map((slot) => {
//       const slotKey = `${dayName}_${dateStr}T${slot.startTime}`;
//       const isBooked = bookedSlots?.includes(slotKey);

//       let isException = false;
//       if (!isBooked && exceptions?.length > 0) {
//         const slotStartMoment = moment.tz(`${dateStr} ${slot.originalStartTime}`, "YYYY-MM-DD HH:mm", specialistTimeZoneRef.current);
//         const slotEndMoment = moment.tz(`${dateStr} ${slot.originalEndTime}`, "YYYY-MM-DD HH:mm", specialistTimeZoneRef.current);

//         isException = exceptions.some((exc) => {
//           const excStart = moment(exc.start);
//           const excEnd = moment(exc.end);
//           if (exc.fullDay) {
//             const excDateStr = excStart.tz(specialistTimeZoneRef.current).format('YYYY-MM-DD');
//             return excDateStr === dateStr;
//           } else {
//             return slotStartMoment.isBefore(excEnd) && slotEndMoment.isAfter(excStart);
//           }
//         });
//       }

//       const isUnavailable = isBooked || isException;

//       return {
//         ...slot,
//         isBooked,
//         isException,
//         isUnavailable
//       };
//     });
//   };

//   const selectedDateSlots = getSelectedDateSlots();

//   const handleCreate = async () => {
//     if (!selectedSlot || !selectedDate) {
//       toast.warning("Please select a date and time slot");
//       return;
//     }

//     if (selectedSlot.isUnavailable) {
//       toast.error("This slot is unavailable");
//       return;
//     }

//     const userTZ = userRole === "specialist" ? specialistTimeZoneRef.current : Intl.DateTimeFormat().resolvedOptions().timeZone;

//     const payload = userRole === "specialist" ? {
//       appointmentDate: moment(selectedDate).format("YYYY-MM-DD"),
//       startTime: selectedSlot?.startTime,
//       endTime: selectedSlot?.endTime,
//       timeZone: userTZ,
//     } : {
//       startTimeUTC: selectedSlot?.startTime,
//       endTimeUTC: selectedSlot?.endTime,
//       timeZone: userTZ,
//     };

//     if (userRole === "specialist") {
//       payload.memberId = memberId;
//     } else {
//       payload.specialistId = specialistId;
//     }
//     // dispatch(
//     //   showDialogWithData({
//     //     type: APPOINTMENT_SCHEDULE,
//     //     data: payload
//     //   })
//     // );
//     dispatch(
//       showDialogWithData({
//         type: APPOINTMENT_SCHEDULE,
//         data: {
//           ...payload,

//           mode: isReschedule ? "reschedule" : "schedule",

//           appointmentId: modalData?.appointmentId,

//           slotId: selectedSlot?._id,

//           date: moment(selectedDate).format("YYYY-MM-DD"),
//         }
//       })
//     )

//   };

//   return (
//     <>
//       <DialogTitle sx={{ textAlign: "center" }}>
//         {isReschedule ? "Reschedule Appointment" : "Schedule Appointment"}
//       </DialogTitle>

//       <DialogContent dividers>
//         {error && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {error}
//           </Alert>
//         )}

//         {!error && (
//           <>
//             {dayWiseAvailability.length === 0 ? (
//               <Box textAlign={"center"}>
//                 <CircularProgress />
//               </Box>
//             ) : (
//               <>
//                 <AppointmentCalendar
//                   bookedDates={bookedDates}
//                   weeklySchedule={dayWiseAvailability}
//                   selectedDate={selectedDate}
//                   onDateChange={handleDateChange}
//                   onViewAll={() => {
//                     setSelectedDate(null);
//                     setSelectedSlot(null);
//                   }}
//                   appointments={[]}
//                 />

//                 {selectedDate && (
//                   <Box sx={{ mt: 3 }}>
//                     <Typography
//                       variant="subtitle2"
//                       fontWeight={600}
//                       gutterBottom
//                     >
//                       Available Slots –{" "}
//                       {moment(selectedDate).format("dddd, MMM DD, YYYY")}
//                     </Typography>

//                     {selectedDateSlots?.length === 0 ? (
//                       <Alert severity="warning" sx={{ mt: 1 }}>
//                         No slots available for this day.
//                       </Alert>
//                     ) : (
//                       <>
//                         <Stack
//                           direction="row"
//                           flexWrap="wrap"
//                           gap={1}
//                           sx={{ mt: 1 }}
//                         >
//                           {selectedDateSlots?.map((slot, i) => (
//                             <Chip
//                               key={i}
//                               label={`${formatTime(slot?.startTime)} – ${formatTime(slot?.endTime)}${slot?.isUnavailable ? " (Unavailable)" : ""}`}
//                               color={
//                                 selectedSlot?.startTime === slot?.startTime &&
//                                   !slot.isUnavailable
//                                   ? "primary"
//                                   : "default"
//                               }
//                               onClick={() =>
//                                 !slot.isUnavailable && setSelectedSlot(slot)
//                               }
//                               disabled={slot.isUnavailable || moment(`${moment(selectedDate).format("YYYY-MM-DD")} ${slot?.startTime}`).isBefore(moment())}
//                               clickable={!slot.isUnavailable}
//                               sx={{
//                                 minWidth: 130,
//                                 fontSize: "15px",
//                                 fontWeight:
//                                   selectedSlot?.startTime === slot?.startTime
//                                     ? 600
//                                     : 400,
//                                 opacity: slot?.isUnavailable ? 0.6 : 1,
//                                 cursor: slot.isUnavailable
//                                   ? "not-allowed"
//                                   : "pointer",
//                                 textDecoration: slot?.isUnavailable
//                                   ? "line-through"
//                                   : "none",

//                                 backgroundColor:
//                                   selectedSlot?.startTime === slot?.startTime
//                                     ? "#1976d2"
//                                     : slot.isUnavailable
//                                       ? "#d9d9d9ff"
//                                       : "#bbe3fb93",
//                                 color:
//                                   selectedSlot?.startTime === slot?.startTime
//                                     ? "white"
//                                     : slot.isUnavailable
//                                       ? "#000000ff"
//                                       : "#000000ff",
//                               }}
//                             />
//                           ))}
//                         </Stack>

//                         {selectedDateSlots.every((s) => s.isUnavailable) && (
//                           <Alert severity="warning" sx={{ mt: 2 }}>
//                             All slots are unavailable for this date. Please select
//                             another date.
//                           </Alert>
//                         )}
//                       </>
//                     )}
//                   </Box>
//                 )}
//               </>
//             )}
//           </>
//         )}
//       </DialogContent>

//       <DialogActions>
//         <Button onClick={handleClose}>Cancel</Button>
//         <Button
//           variant="contained"
//           onClick={handleCreate}
//           disabled={
//             !selectedSlot ||
//             !selectedDate ||
//             selectedSlot?.isUnavailable
//           }
//         >
//           {isReschedule ? "Reschedule" : "Schedule"}
//         </Button>
//       </DialogActions>
//     </>
//   );
// };

// export default FollowupAppointmentDialog;


import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Stack,
  Chip,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment-timezone";
import SlotPrev from "./appointment/SlotPrev";
import AppointmentCalendar from "../../dashboard/Appointment/AppointmentCalender";

import {
  handleGetAvailableFollowupSlots,
} from "../../../redux/user-slices/appointment.slice";

import {
  hideDialog,
  showDialogWithData,
} from "../../../redux/guest-slices/other.slice";

import { useToast } from "../../../hooks/useToast";

import {
  checkUserType,
  processAvailabilityOnFrontend,
} from "../../../utils/helper";

import { APPOINTMENT_SCHEDULE } from "../../../utils/keywords";

import { getAllAppointmentSlots } from "../../../redux/member-slices/appointments.slice";

const FollowupAppointmentDialog = () => {
  const dispatch = useDispatch();
  const toast = useToast();

  const { data: modalData } = useSelector((s) => s.otherSlice);

  const specialistTimeZoneRef = useRef("");

  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [exchangeRate, setExchangeRate] = useState(null);

  const [dayWiseAvailability, setDayWiseAvailability] = useState([]);
  const [bookedDates, setBookedDates] = useState([]);

  const [slots, setSlots] = useState([]);
  const [isFetchingSlots, setIsFetchingSlots] = useState(false);

  const [error, setError] = useState(null);

  const memberId = modalData?.memberId;
  const specialistId = modalData?.specialistId;

  const userRole = checkUserType();

  const isReschedule = modalData?.mode === "reschedule";

  const handleClose = () => dispatch(hideDialog());

  function handleSelectSlot(slot) {
    setSelectedSlot(slot);
    setError(null);
  }

  // ─────────────────────────────────────
  // FETCH CALENDAR AVAILABILITY
  // ─────────────────────────────────────
  useEffect(() => {
    if (!memberId && !specialistId) return;

    const fetchAvailability = async () => {
      try {
        setError(null);

        const params =
          userRole === "specialist"
            ? { memberId }
            : { specialistId };

        const res = await dispatch(
          handleGetAvailableFollowupSlots(params)
        ).unwrap();

        const userTZ =
          userRole === "specialist"
            ? res?.specialistTimeZone
            : Intl.DateTimeFormat().resolvedOptions().timeZone;

        specialistTimeZoneRef.current = userTZ;

        const {
          weeklySchedule,
        } = processAvailabilityOnFrontend(res, userTZ);

        setDayWiseAvailability(weeklySchedule || []);

        // generate available dates
        const dates = [];

        const endDate = moment().add(12, "months");

        for (
          let date = moment().add(1, "day");
          date.isBefore(endDate);
          date.add(1, "day")
        ) {
          const dayName = date.format("dddd").toUpperCase();

          const daySchedule = weeklySchedule?.find(
            (d) => d?.day === dayName
          );

          if (daySchedule) {
            dates.push({
              date: date.format("YYYY-MM-DD"),
              count: daySchedule?.slots?.length || 0,
              totalSlots: daySchedule?.slots?.length || 0,
            });
          }
        }

        setBookedDates(dates);
      } catch (err) {
        console.log(err);
        setError("Failed to fetch availability.");
      }
    };

    fetchAvailability();
  }, [memberId, specialistId, userRole, dispatch]);

  // ─────────────────────────────────────
  // FORMAT TIME
  // ─────────────────────────────────────
  const formatTime = (timeStr) => {
    if (!timeStr) return "Invalid Time";

    if (timeStr.includes("T") || timeStr.includes("Z")) {
      const m = moment(timeStr);

      return m.isValid()
        ? m.format("h:mm A")
        : "Invalid Time";
    }

    const m = moment(timeStr, "HH:mm");

    return m.isValid()
      ? m.format("h:mm A")
      : "Invalid Time";
  };

  // ─────────────────────────────────────
  // FETCH SLOTS ON DATE SELECT
  // ─────────────────────────────────────
  const handleDateChange = async (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
    setExchangeRate(null);

    try {
      setIsFetchingSlots(true);

      const payload = {
        date: moment(date).format("YYYY-MM-DD"),
        specialistId,
      };

      const res = await dispatch(
        getAllAppointmentSlots(payload)
      ).unwrap();

      setSlots(res?.data?.slots || []);
      if (res?.data?.exchangeRate) setExchangeRate(res.data.exchangeRate);
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch slots");
      setSlots([]);
    } finally {
      setIsFetchingSlots(false);
    }
  };

  const selectedDateSlots = slots || [];

  // ─────────────────────────────────────
  // CREATE / RESCHEDULE
  // ───────────────────────────────────── 
  const handleCreate = async () => {
    if (!selectedSlot || !selectedDate) {
      toast.warning("Please select a date and time slot");
      return;
    }

    if (selectedSlot?.isUnavailable) {
      toast.error("This slot is unavailable");
      return;
    }

    const userTZ =
      userRole === "specialist"
        ? specialistTimeZoneRef.current
        : Intl.DateTimeFormat().resolvedOptions().timeZone;

    const payload =
      userRole === "specialist"
        ? {
          appointmentDate: moment(selectedDate).format("YYYY-MM-DD"),
          startTime: selectedSlot?.startTime,
          endTime: selectedSlot?.endTime,
          timeZone: userTZ,
        }
        : {
          startTimeUTC: selectedSlot?.startTime,
          endTimeUTC: selectedSlot?.endTime,
          timeZone: userTZ,
        };

    if (userRole === "specialist") {
      payload.memberId = memberId;
    } else {
      payload.specialistId = specialistId;
    }

    dispatch(
      showDialogWithData({
        type: APPOINTMENT_SCHEDULE,
        data: {
          ...payload,

          mode: isReschedule
            ? "reschedule"
            : "schedule",

          appointmentId: modalData?.appointmentId,

          slotId: selectedSlot?.slotId,

          date: moment(selectedDate).format("YYYY-MM-DD"),
        },
      })
    );
  };

  return (
    <>
      <DialogTitle sx={{ textAlign: "center" }}>
        {isReschedule
          ? "Reschedule Appointment"
          : "Schedule Appointments"}
      </DialogTitle>

      <DialogContent dividers>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        {!error && (
          <>
            {dayWiseAvailability.length === 0 ? (
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                <AppointmentCalendar
                  bookedDates={bookedDates}
                  weeklySchedule={dayWiseAvailability}
                  selectedDate={selectedDate}
                  onDateChange={handleDateChange}
                  onViewAll={() => {
                    setSelectedDate(null);
                    setSelectedSlot(null);
                  }}
                  appointments={[]}
                />

                {selectedDate && (
                  <Box sx={{ mt: 3 }}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      gutterBottom
                    >
                      Available Slots –{" "}
                      {moment(selectedDate).format(
                        "dddd, MMM DD, YYYY"
                      )}
                    </Typography>

                    {/* {isFetchingSlots ? (
                      <Box textAlign="center" sx={{ py: 3 }}>
                        <CircularProgress size={30} />
                      </Box>
                    ) : selectedDateSlots?.length === 0 ? (
                      <Alert severity="warning" sx={{ mt: 1 }}>
                        No slots available for this day.
                      </Alert>
                    ) : (
                      <>
                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          gap={1}
                          sx={{ mt: 1 }}
                        >
                          {selectedDateSlots?.map((slot, i) => {
                            const isPast = moment(
                              `${moment(selectedDate).format(
                                "YYYY-MM-DD"
                              )} ${slot?.startTime}`
                            ).isBefore(moment());

                            return (
                              <Chip
                                key={i}
                                label={`${formatTime(
                                  slot?.startTime
                                )} – ${formatTime(
                                  slot?.endTime
                                )}`}

                                color={
                                  selectedSlot?._id === slot?._id
                                    ? "primary"
                                    : "default"
                                }

                                onClick={() => {
                                  if (!isPast) {
                                    setSelectedSlot(slot);
                                  }
                                }}

                                disabled={isPast}

                                clickable={!isPast}

                                sx={{
                                  minWidth: 130,
                                  fontSize: "15px",

                                  fontWeight:
                                    selectedSlot?._id === slot?._id
                                      ? 600
                                      : 400,

                                  opacity: isPast ? 0.6 : 1,

                                  cursor: isPast
                                    ? "not-allowed"
                                    : "pointer",

                                  textDecoration: isPast
                                    ? "line-through"
                                    : "none",

                                  backgroundColor:
                                    selectedSlot?._id === slot?._id
                                      ? "#1976d2"
                                      : isPast
                                        ? "#d9d9d9"
                                        : "#bbe3fb93",

                                  color:
                                    selectedSlot?._id === slot?._id
                                      ? "#fff"
                                      : "#000",
                                }}
                              />
                            );
                          })}
                        </Stack>
                      </>
                    )} */}
                    {isFetchingSlots ? (
                      <Stack direction="row" justifyContent="center" mt={2}>
                        <CircularProgress size={22} />
                      </Stack>
                    ) : (
                      <SlotPrev slots={selectedDateSlots} handleSelectSlot={handleSelectSlot} exchangeRate={exchangeRate} />
                    )}
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={handleCreate}
          disabled={!selectedSlot || !selectedDate}
        >
          {isReschedule ? "Reschedule" : "Schedule"}
        </Button>
      </DialogActions>
    </>
  );
};

export default FollowupAppointmentDialog;

